export default function initCustomDropdown (containerSelector, options = {}) {
    const container = document.querySelector(containerSelector);
    if (!container) return;
 console.log("initCustomDropdown");
    const dropdown = container.querySelector('.state-dropdown');
    const toggle = dropdown.querySelector('.dropdown-toggle');
    const menu = dropdown.querySelector('.dropdown-menu');
    const selected = dropdown.querySelector('[data-selected]');
    const hiddenInput = dropdown.querySelector('input[type="hidden"]');
    const getCardBtn = container.querySelector('#getCardBtn');

    let selectedValue = "";

    toggle.addEventListener('click', () => {
        const isOpen = dropdown.classList.contains('open');
        menu.style.display = isOpen ? 'none' : 'block';
        dropdown.classList.toggle('open', !isOpen);
        dropdown.classList.remove('error');
    });

    dropdown.querySelectorAll('.dropdown-menu li').forEach(item => {
        item.addEventListener('click', () => {
            selectedValue = item.getAttribute('data-value');
            selected.textContent = item.textContent;
            menu.style.display = 'none';
            dropdown.classList.remove('error', 'open');
        });
    });

    document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target)) {
            menu.style.display = 'none';
            dropdown.classList.remove('open');
        }
    });

    if (getCardBtn) {
        getCardBtn.addEventListener('click', () => {
            if (!selectedValue) {
                dropdown.classList.add('error');
            } else {
                const url = options.redirectUrl || `/appointment/start?state=${selectedValue}`;
                window.location.href = url;
            }
        });
    }

    return {
        getSelectedValue: () => selectedValue,
        setError: () => dropdown.classList.add('error'),
        clearError: () => dropdown.classList.remove('error'),
        isSelected: () => Boolean(selectedValue),
        reset: () => {
            selectedValue = "";
            selected.textContent = 'Select State';
            hiddenInput.value = '';
            dropdown.classList.remove('error', 'open');
            menu.style.display = 'none';
        }
    };
}
